
// 新的增值系统请求
import axios from 'axios';
import { cookieGet } from '@/common/cookie';
// import { Message } from 'element-ui'
import { isObject } from 'lodash';
// import store from '@/store'
import Vue from 'vue';
import { Notify, Toast } from 'vant';

const uuid = require('uuid');
const CryptoJS = require('crypto-js');

axios.defaults.baseMediaURL = process.env.NODE_ENV === 'production' ? '../' : '/media';

Vue.use(Notify);
// 记录和显示错误
// function errorLog(info) {
  // Notify({ type: 'danger', message: info })
  // 显示提示
  // Message({
  //   message: info,
  //   type: 'error',
  //   duration: 5 * 1000
  // })
// }

const needBackResponseCodes = [7003, 7007, 7009, 7011, 7012, 7013, 7014, 7015, 7016, 7017];

// 创建一个 axios 实例VUE_APP_BASE_API
const request = axios.create({
  baseURL: process.env.NODE_ENV === 'production' ? '../' : '/vas',
  timeout: 1000 * 30,
  withCredentials: true,
  headers: {
    'content-type': 'application/json;charset=UTF-8'
  }
});

// 日期格式函数
// eslint-disable-next-line no-extend-native
Date.prototype.Format = function(fmt) {
  const o = {
    'M+': this.getMonth() + 1, // 月份
    'd+': this.getDate(), // 日
    'h+': this.getHours(), // 小时
    'm+': this.getMinutes(), // 分
    's+': this.getSeconds(), // 秒
    'q+': Math.floor((this.getMonth() + 3) / 3), // 季度
    S: this.getMilliseconds() // 毫秒
  };
  if (/(y+)/.test(fmt)) { fmt = fmt.replace(RegExp.$1, (`${this.getFullYear()}`).substr(4 - RegExp.$1.length)); }
  for (const k in o) {
    if (new RegExp(`(${k})`).test(fmt)) { fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : ((`00${o[k]}`).substr((`${o[k]}`).length))); }
  }
  return fmt;
};

function makeParams(needSign, data) {
  if (needSign) {
    const reqId = uuid();
    const requestTime = new Date().Format('yyyy-MM-dd hh:mm:ss');
    const version = process.env.VUE_APP_VERSION;

    const signKey = cookieGet('signKey');
    const sign = CryptoJS.HmacSHA1(reqId + requestTime + version + JSON.stringify(data), signKey).toString(CryptoJS.enc.Hex);
    return {
      sign,
      requestId: reqId,
      requestTime,
      version
    };
  }
  return {
    data: '',
    sign: '',
    requestId: uuid(),
    requestTime: new Date().Format('yyyy-MM-dd hh:mm:ss'),
    version: process.env.VUE_APP_VERSION
  };
}

// 请求拦截
request.interceptors.request.use((config) => {
  // 参数有 orderKey 的是 h5 下单，不用拦截
  // cookie 有 token 的是华安 h5 下单，不用拦截
  // if (!config.data.orderKey && !cookieGet('token')) {
  //   // Notify({ type: 'danger', message: '登录过期,请重新登录' })
  //   // router.push({
  //   //   name: "login"
  //   // });
  //   return false;
  // }

  // console.log('token:', cookieGet('token'));

  if (!config.public && !config.data.orderKey && !cookieGet('token')) {
    return false;
  }

  config.headers['content-type'] = 'application/json;charset=UTF-8';
  config.headers['Accept-Language'] = cookieGet('language') || 'zh-CN';
  config.headers.appType = 1;
  // 默认参数
  // TODO: 暂时都不签名
  let needSign = true;

  if (
    config.data?.orderKey || // 有 orderKey 的不要签名
    config.public /* public不需签名 */
  ) {
    needSign = false;
  }
  const defaults = makeParams(needSign, config.data);
  // 防止缓存，GET请求默认带_t参数
  if (config.method === 'get') {
    config.params = {
      ...config.params,
      ...{ _t: new Date().getTime() }
    };
  }
  if (isObject(config.params)) {
    config.params = {
      ...defaults,
      ...config.params
    };
  }
  if (isObject(config.data)) {
    config.data = {
      ...defaults,
      ...{
        data: JSON.stringify(config.data)
      }
    };
    // config.data = JSON.stringify(config.data);
    // if (/^application\/x-www-form-urlencoded/.test(config.headers['content-type'])) {
    //   config.data = qs.stringify(config.data)
    // }
  }
  console.log(config);
  return config;
}, error => Promise.reject(error));

/**
 * 响应拦截
 */
request.interceptors.response.use((response) => {
  if (Number(response.data.code) === 401 || Number(response.data.code) === 10001) {
    // Notify({ type: 'danger', message: '无资源访问权限,新登录' })
    // store.dispatch('d2admin/account/logout')
    return Promise.reject(response.data.message);
  }
  if (Number(response.data.code) !== 200) {
    // 特殊处理
    if (needBackResponseCodes.includes(Number(response.data.code))) {
      return response.data;
    }
    // Notify(response.data.message)
    // noError为接口不报错的
    if (!response.config.noError) {
        Toast(response.data.message);
    }
    return Promise.reject(response);
  }
  if (isObject(response.data.data)) {
    return response.data.data;
  }
  if (typeof (response.data.data) === 'string' && response.data.data !== '') {
    // return JSON.parse(response.data.data);
    return response.data.data;
  }

  return response.data.data;
}, (error) => {
  try {
    if (error.message.includes('timeout')) {
      const msg = '网络超时';
      Toast(msg);
    } else {
      const msg = error.response.data.message;
      Toast(msg);
    }
  } catch (e) {
    console.log(e);
  }
  return Promise.reject(error);
});
// export let judgeLogOut = true;
// function errorHandle(response) {
//   if (response.data.code === 401 || response.data.code === 403 || response.data.code === 406) {
//     Notify({ type: 'danger', message: '登陆过期,新重新登录' })
//     window.SITE_CONFIG['dynamicMenuRoutesHasAdded'] = false
//     cookieRemove('token', {
//       domain: 'cias.cn',
//     });
//     cookieRemove('signKey', {
//       domain: 'cias.cn',
//     });
//     judgeLogOut = false;
//     router.push({
//       name: "login"
//     });
//   } else if (response.data.code === 702) {
//     Notify({ type: 'danger', message: '登录过期,请重新登录' })
//     window.SITE_CONFIG['dynamicMenuRoutesHasAdded'] = false
//     cookieRemove('token', {
//       domain: 'cias.cn',
//     });
//     cookieRemove('signKey', {
//       domain: 'cias.cn',
//     });
//     judgeLogOut = false;
//     router.push({
//       name: "login"
//     });
//   } else {
//     errorLog(response.data.message);
//   }
// }

export default request;
